import axios from "axios";
import BASE_URL from "../_helpers/constants";
import { readCurrentUser } from "../_helpers/currentUser";

// Pooled inbox SP6 — the client's linked banks (contract: Astra-Backend
// docs/superpowers/plans/2026-10-05-pooled-inbox-sp6-plan.md § The contract).
// The onboarding.services.js style: each returns the axios response and
// throws on a non-2xx; callers read `res.data` and `err.response.data`.
// Linking itself stays in common.services.js (createPlaidLinkToken,
// exchangePlaidPublicToken), called only by the one link hook.
const authHeaders = () => ({
  Authorization: `Bearer ${readCurrentUser()?.token ?? ""}`,
});

// { consent, links: [{ linkId, institution: { name, kind }, accounts:
// [{ label, mask }], status: 'active'|'needs_attention', linkedAt }] }.
export const getPlaidLinks = () =>
  axios.get(`${BASE_URL}/plaid/links`, { headers: authHeaders() });

// { removed, links } — the links left. Idempotent: an id that is gone, or not
// the caller's, answers removed: false.
export const unlinkPlaidLink = (linkId) =>
  axios.delete(`${BASE_URL}/plaid/links/${encodeURIComponent(linkId)}`, {
    headers: authHeaders(),
  });
